/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ServiceObjectBaseV1Dto } from './ServiceObjectBaseV1Dto';
import type { ServiceObjectPartnerV1Dto } from './ServiceObjectPartnerV1Dto';
export type ServiceObjectPartnerRelationsV1Dto = {
  /**
   * The unique identifier of the entity.
   */
  readonly id: string;
  /**
   * The date when the entity was created.
   */
  readonly createdAt: string;
  /**
   * The date when the entity was modified.
   */
  readonly modifiedAt: string;
  /**
   * The current version of the entity
   */
  version: number;
  /**
   * The service object associated with the service object along with their details
   */
  object: ServiceObjectBaseV1Dto;
  /**
   * The partner associated with the service object along with their details
   */
  partner: ServiceObjectPartnerV1Dto;
  /**
   * Role of the partner associated with the service object, can be either Landlord, Maintenance or Partner
   */
  role: ServiceObjectPartnerRelationsV1Dto.role;
};
export namespace ServiceObjectPartnerRelationsV1Dto {
  /**
   * Role of the partner associated with the service object, can be either Landlord, Maintenance or Partner
   */
  export enum role {
    LANDLORD = 'Landlord',
    MAINTENANCE = 'Maintenance',
    PARTNER = 'Partner',
  }
}
